<template>
    <div style="overflow: hidden; margin-bottom: 48px;">
        <div class="container home-chart">
          <div class="home-block-wrap">
            <div class="block-title">
              <div class="block-title-left">
                <a href="/">
                  <span>
                    <span>积木</span>
                  </span>
                </a>
              </div>
              
            </div>
            <div class="home-block-content-wrap">
              <div class="home-block-list-wrap">
                <div class="home-block-list-main " style="width: 200%;">
                  <div class="home-block-list">
                    <div class="block-item ">
                      <div>
                        <div class="block-top">
                          <span class="block-number">71242719</span>
                          <a class="block-producer" href="/address/TAAdjpNYfeJ2edcETNpad1QpQWJfyBdB9V">
                            <span>Ant Investment Group</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>8 secs ago</div>
                          </div>
                          <div>
                            <b>449 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>574.57177 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item false">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242718</span>
                          <a class="block-producer" href="/address/TVFKwzE8qeETLaZEHMx2tjEsdnujAgAWaA">
                            <span>BlockchainOrg</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>11 secs ago</div>
                          </div>
                          <div>
                            <b>377 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>440.87638 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item false">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242717</span>
                          <a class="block-producer" href="/address/TAQpCTFeJvwdWf6MQZtXXkzWrTS9aymshb">
                            <span>Abra Capital Management</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>14 secs ago</div>
                          </div>
                          <div>
                            <b>457 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>770.27237 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item false">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242716</span>
                          <a class="block-producer" href="/address/TSMC4YzUSfySfqKuFnJbYyU3W6PBebBk2E">
                            <span>Smart Consensus</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>18 secs ago</div>
                          </div>
                          <div>
                            <b>399 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>391.22343 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="home-block-list">
                    <div class="block-item undefined">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242715</span>
                          <a class="block-producer" href="/address/TQ4bh4nQknQp33vuf1mUAKu5M5TWW8cTAD">
                            <span>Intelligence Quant</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>21 secs ago</div>
                          </div>
                          <div>
                            <b>511 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>528.29369 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item undefined">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242714</span>
                          <a class="block-producer" href="/address/TJBtdYunmQkeK5KninwgcjuK1RPDhyUWBZ">
                            <span>JD Investment</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>23 secs ago</div>
                          </div>
                          <div>
                            <b>438 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>268.29531 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item undefined">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242713</span>
                          <a class="block-producer" href="/address/TGyrSc9ZmTdbYziuk1SKEmdtCdETafewJ9">
                            <span>Luganodes</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>27 secs ago</div>
                          </div>
                          <div>
                            <b>459 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>480.99753 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="block-item undefined">
                      <div>
                        <div class="block-top">
                          <span class="block-number">#71242712</span>
                          <a class="block-producer" href="/address/TGJBjL8wmRVyRStkghnhcVNYYgn6Yjno6X">
                            <span>BlockAnalysis</span>
                            <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                              <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                            </svg>
                          </a>
                        </div>
                        <div class="block-time">
                          <div class="token_black table_pos">
                            <div>30 secs ago</div>
                          </div>
                          <div>
                            <b>474 <span>交易</span>
                            </b>
                          </div>
                        </div>
                        <div class="block-detail">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <span>报酬 </span>
                              <b>176 TRX</b>
                            </div>
                            <div>
                              <svg class="icon tron-icon tron-icon-fire" aria-hidden="true">
                                <use xlink:href="/static/media/icons.svg#icon-icon-fire"></use>
                              </svg>
                              <b>542.87231 TRX</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block-bg-animate-wrap">
                <div>
                  <div class="slider-move"></div>
                </div>
              </div>
              <div class="block-list-mask block-list-after mask-opacity">
                <span class="">
                  <svg class="icon tron-icon tron-arrow-icon" aria-hidden="true">
                    <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 48px">
        <p></p>
      </div>
</template>

<script>

    export default {
        name: "TronBlocks",
        data() {
            return {

            }
        },
        methods: {

        }
    }

</script>

<style scoped>
  .loading-overlay {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
    }

    .spinner {
        border: 4px solid #eee;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
</style>